import React from 'react';

import { getConfigState } from '../../../store/ConfigSlice';
import { useAppSelector } from '../../../hooks';
import { checkUserPermission } from '../../../helper';
import { getAuthState } from '../../../store/AuthSlice';
import TrialClasses from './TrialClasses';
import AdminTrialClasses from './admin/AdminTrialClasses';
import { USER_PERMISSION_INDIVIDUALS } from '../../../store/V2/RolesSlice';
import { getTenantsState } from '../../../store/V2/TenantsSlice';

const TrialClassPage: React.FC = () => {
  // Store
  const authState = useAppSelector(getAuthState);
  const tenantState = useAppSelector(getTenantsState);
  const configState = useAppSelector(getConfigState);

  const { user: authUser } = authState;
  const { appTenant } = tenantState;
  const { adminEditMode } = configState;

  if (
    adminEditMode &&
    checkUserPermission({
      authUser,
      tenant: appTenant,
      permissions: {
        adminTrialClass: [USER_PERMISSION_INDIVIDUALS.ADMIN_TRIAL_CLASS_VIEW],
      },
    })
  ) {
    return <AdminTrialClasses />;
  }

  return <TrialClasses />;
};

export default TrialClassPage;
